export default {
    'europa1': {
        "zoom": 4,
        "mapLayout": "horizontal",
    },
    'europa2': {
        "zoom": 5,
        "mapLayout": "vertical",
    },
    'sverige': {
        "zoom": 6,
        "mapLayout": "vertical",
    },
    'varlden': {
        "center": [24.126701958681682, 16.347656250000004],
        "zoom": 3,
        "mapLayout": "horizontal",
    },
}
